<template>
  <div class="ballot d-flex flex-column">
    <div class="h4 order-1" v-if="ballot.question">
      {{ ballot.question[$i18n.locale] }}
    </div>
    <Result v-if="result" class="order-2" :header="result.feedback" :result="result" :vote-count="voteCount" :slide="ballot" />
    <div v-if="!result || !result.publicised" class="lead mb-3 order-0" v-html="description"></div>
    <div v-if="showTurnoutElement" class="mt-3 order-3">
      <BallotProgress :ballot="ballot" class="mb-1"/>
    </div>
  </div>
</template>

<script>
    import {mapGetters, mapState} from 'vuex'
    import Result from '../shared/Result'
    import Progress from '../../shared/Progress'
    import Option from "../shared/Option";
    import Countdown from "../shared/Countdown";
    import BallotProgress from "../shared/BallotProgress";

    export default {
        inject: ['stickyAlertsSubscribe'],
        components: {
          BallotProgress,
            Countdown,
            Option,
            Result,
            Progress
        },
        props: {
            ballot: Object
        },
        data(){
            return {
                showErrors: false,
                showTurnout: true,
            }
        },
        computed: {
            ...mapState(['election', 'voterCounts']),
            ...mapGetters(['firstAvailableLocale']),
            result(){
                return this.ballot.result
            },
            presentVoters(){
                return this.result ? this.result.voterCounts.activeEligiblesOrVoted : Math.max(this.voterCounts.activeEligiblesOrVoted, this.voteCount, 0)
            },
            voteCount(){
              if(this.ballot){
                return this.ballot.disregardWeights ? this.ballot.voteCount : this.ballot.votesCombinedWeight
              }
              return null
            },
            showTurnoutElement(){
                return this.showTurnout && (this.ballotStateIn(['open','countdown']))
            },
            stickies(){
                let stickies = []
                if(this.ballot){
                    stickies.push({type: 'ballotStatus', ballot: this.ballot})
                }
                return stickies
            },
            description(){
                return this.ballot.description[this.firstAvailableLocale];
            },
        },
        methods: {
            ballotStateIn(ballotStates) {
                if(this.ballot){
                    if(Array.isArray(ballotStates)){
                        return ballotStates.includes(this.ballot.state)
                    } else {
                        return ballotStates === this.ballot.state
                    }
                }
                return false
            }
        },
        mounted() {
            this.stickyAlertsSubscribe(this)
        }
    }
</script>